// extracted by mini-css-extract-plugin
export default {"borderBottom":"AdminMobileMonthSaleStat_borderBottom__FnOVO","prevIcon":"AdminMobileMonthSaleStat_prevIcon__U2FHh","nextIcon":"AdminMobileMonthSaleStat_nextIcon__chxMX"};